module.exports = __webpack_public_path__ + "img/paper.2e235f9a.svg";